import { configureStore } from "@reduxjs/toolkit";
import type { PreloadedState } from "@reduxjs/toolkit";

import { RootState, rootReducer } from "./rootReducer";
import { persistStore } from "redux-persist";
import { clinicIdMiddleware } from "./clinicIdMiddleware";

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat(
      clinicIdMiddleware
    ),
});

export const setupStore = (preloadedState?: PreloadedState<RootState>) => {
  return configureStore({
    reducer: rootReducer,
    preloadedState,
  });
};

export type AppDispatch = typeof store.dispatch;

export const persistedStore = persistStore(store);

export type AppStore = ReturnType<typeof setupStore>;

export default store;
